export type McpCallSocketRawMessage = { data?: unknown };

type McpCallSocketListener = (message: McpCallSocketRawMessage) => void;

const listeners = new Set<McpCallSocketListener>();

export function subscribeMcpCallSocket(
  listener: McpCallSocketListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function dispatchMcpCallSocketEvent(message: McpCallSocketRawMessage) {
  listeners.forEach(l => {
    l(message);
  });
}
